import { inject, Injectable } from "@angular/core";
import { idField, ReferenceField } from "@common/references/reference-field";
import { DefaultService } from "@common/references/default.service";
import urlJoin from "url-join";
import { environment } from "@environments/environment";
import { Reading } from '@modules/universal-billing/reading/reading.interfaces';
import { HttpClient } from '@angular/common/http';
import { MeterPipe } from '@common/pipe/meter.pipe';
import { FullNamePipe } from '@common/pipe/full-name.pipe';
import { Observable } from 'rxjs';
import { PageResult } from '@shared/components/classes/page-result';
import { map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { ReadingSource } from './readingSource.enum';

@Injectable({
  providedIn: "root",
})
export class ReadingService extends DefaultService<Reading> {
  backendName = 'readings';
  _http = inject(HttpClient);
  _translate = inject(TranslateService);
  meterPipe = new MeterPipe();
  fullNamePipe = new FullNamePipe();

  fields: ReferenceField[] = [
    {
      fieldName: 'name',
      label: 'READINGS.METER',
      iconClass: 'bx bx-tachometer',
      filter: true,
      fieldValue: (item,data) => data.meter?.serialNumber
    },
    {
      fieldName: 'meter',
      label: 'METER_TYPE.UTILITY_TYPE',
      iconClass: 'las la-cube',
      viewType: 'unitType',
      fieldValue: (item, data) => data?.meter?.unitType
    },
    {
      fieldName: 'readingValue',
      label: 'READINGS.READING',
      iconClass: "bx bx-timer",
      filter: true
    },
    {
      fieldName: 'readingSource',
      label: 'READINGS.SOURCE',
      iconClass: "bx bx-pie-chart-alt-2",
      filter: true,
      fieldValue: (item, data) => this._translate.instant(`READINGS.${data.readingSource.toUpperCase()}`),
    },
    {
      fieldName: 'readingDate',
      label: 'REPAIRS.DATE',
      iconClass: "las la-calendar-alt"
    },
    {
      fieldName: 'period',
      label: 'APARTMENT.PERIOD',
      iconClass: "las la-calendar-alt",
      viewType: 'period'
    }
  ];

  hasActions = true;
  hasAdd = true;
  hasDelete = true;
  hasEdit = false;

  getUrl(): string {
    return urlJoin(environment.apiUrl, 'readings');
  }

  getAll(params: any = {}): Observable<PageResult<Reading>> {
    params.orderType = 'desc';
    return super.getAll(params).pipe(map(data => {
      data.data = data.data.map(item => {
        item.utilityProviderType = item.meter.utilityProviderType;
        item.utilityProviderTypeId = item.meter.utilityProviderTypeId;
        return item;
      });
      return data;
    }));
  }

}
